// zh — checkin/quickCheck/stepTracker blocks translated.
export const zh = {
  "common": {
    "loading": "加载中…",
    "save": "保存",
    "cancel": "取消",
    "delete": "删除",
    "edit": "编辑",
    "close": "关闭",
    "confirm": "确认",
    "back": "返回",
    "next": "下一步",
    "submit": "提交",
    "search": "搜索",
    "select": "选择",
    "or": "或",
    "and": "和",
    "note": "Note",
    "viewAll": "查看全部",
    "learnMore": "了解更多",
    "getStarted": "开始",
    "continue": "继续",
    "saving": "保存中…"
  },
  "nav": {
    "dashboard": "仪表盘",
    "nutrition": "智能营养",
    "family": "家庭",
    "checkIn": "每日签到",
    "insights": "Insights",
    "trends": "Trends",
    "habits": "Habits",
    "medications": "药物",
    "expertSupport": "Expert Support",
    "profile": "个人资料",
    "healthHub": "Health Hub",
    "support": "帮助与支持",
    "wellness": "Wellness",
    "education": "Education",
    "community": "Community",
    "preventiveHealth": "Preventive Health",
    "womensHealth": "Women's Health",
    "reminders": "Health Reminders",
    "meals": "Meals",
    "orders": "Orders",
    "subscription": "Subscription",
    "logout": "退出登录"
  },

  "navShort": {
    "dashboard": "首页",
    "nutrition": "营养",
    "family": "家庭",
    "care": "服务",
    "support": "帮助",
    "profile": "我的"
  },
  "auth": {
    "login": "登录",
    "register": "注册账户",
    "logout": "Sign Out",
    "email": "邮箱",
    "password": "密码",
    "name": "Full Name",
    "forgotPassword": "Forgot Password?",
    "noAccount": "还没有账户？",
    "haveAccount": "Already have an account?",
    "signInHere": "Sign in here",
    "signUpHere": "Sign up here",
    "welcomeBack": "欢迎回来！",
    "getStarted": "Let's get started",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "vendorLogin": "Vendor Login",
    "createOne": "创建账户",
    "tagline": "关注健康 —— 每天一个简单签到。",
    "takes30s": "不到 30 秒",
    "emailPlaceholder": "you@example.com",
    "passwordPlaceholder": "Enter your password",
    "checking": "Checking…",
    "continue": "继续",
    "secureMessage": "Secure and private — your data stays protected",
    "biometricSoon": "Biometric login — Coming Soon",
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "vendor": {
      "title": "供应商伙伴登录",
      "subtitle": "访问您的 HealthLoop 供应商管理面板",
      "businessEmail": "商务邮箱",
      "emailPlaceholder": "vendor@business.com",
      "passwordPlaceholder": "••••••••",
      "signingIn": "正在登录...",
      "signIn": "登录",
      "notVendorYet": "还不是供应商合作伙伴？",
      "registerBusiness": "注册您的业务",
      "areYouUser": "您是普通用户吗？",
      "userLogin": "用户登录",
      "welcomeBackToast": "欢迎回来！",
      "genericError": "登录失败，请稍后重试。"
    },
    "admin": {
      "backToUserLogin": "用户登录",
      "title": "管理员登录",
      "restrictedBadge": "受限访问",
      "tagline": "HealthLoop 操作控制台 — 仅限管理员访问。",
      "emailLabel": "管理员邮箱",
      "emailPlaceholder": "admin@yourdomain.com",
      "passwordLabel": "密码",
      "passwordPlaceholder": "请输入您的管理员密码",
      "signingIn": "正在登录...",
      "submit": "登录管理控制台",
      "secureNote": "安全连接 · 会话已加密",
      "restrictedTitle": "此区域仅限管理员访问。",
      "restrictedBody": "您的账号已登录，但没有管理员权限。请退出并尝试其他账号，或返回主应用。",
      "signOut": "退出登录",
      "backToApp": "返回应用"
    }
  },
  "quickCheck": {
    "header": {
      "title": "您今天感觉如何？",
      "subtitle": "快速检查 —— 只需不到 60 秒"
    },
    "section1": {
      "title": "您今天注意到了什么？",
      "hint": "（选择所有适用项）"
    },
    "environment": {
      "title": "今日环境",
      "hint": "帮助我们了解您身处的环境"
    },
    "basicChecks": {
      "title": "快速基础检查",
      "hint": "可选填写，但对分析很有帮助"
    },
    "validation": {
      "pickOne": "请至少回答一个问题"
    },
    "submit": {
      "cta": "获取健康见解",
      "saving": "保存中...",
      "analyzing": "正在分析您的健康趋势...",
      "savedToast": "✅ 打卡已保存！正在生成健康见解..."
    }
  },
  "stepTracker": {
    "header": {
      "title": "计步器",
      "subtitle": "真实、专注本地的活动记录",
      "backToDashboard": "返回个人看板"
    },
    "today": {
      "title": "今日步数",
      "goalProgress": "{{current}} / {{goal}} 步",
      "goalReached": "目标达成 —— 做得好！",
      "keepGoing": "继续加油 —— 您正稳步前进。"
    },
    "streak": {
      "label": "当前连续达标",
      "days": "{{count}} 天",
      "daysPlural": "{{count}} 天"
    },
    "badges": {
      "title": "勋章",
      "empty": "养成习惯后，您将获得专属勋章。"
    },
    "reminders": {
      "title": "活动提醒",
      "hint": "在久坐时提醒您起来走一走。",
      "enabled": "已开启",
      "disabled": "已关闭"
    },
    "insights": {
      "weeklyAverage": "周平均步数",
      "weeklyGoal": "每周目标"
    },
    "actions": {
      "connect": "关联步数来源",
      "manualLog": "手动记录步数",
      "changeGoal": "更改每日目标"
    }
  },
  "checkin": {
    "header": {
      "title": "每日健康打卡",
      "subtitle": "只需不到 60 秒",
      "restDayLink": "今天想休息一下"
    },
    "snapshot": {
      "title": "您的看板已更新",
      "healthScore": "健康评分",
      "todayTasks": "今日任务",
      "dayStreak": "天连续打卡"
    },
    "resume": {
      "banner": "已回到您上次离开的地方",
      "startFresh": "重新开始",
      "dismiss": "忽略"
    },
    "progress": {
      "allSet": "准备就绪",
      "step": "第 {{current}} 步，共 {{total}} 步",
      "ariaLabel": "每日打卡进度：已完成 {{done}} / {{total}} 个部分"
    },
    "insights": {
      "title": "您的健康见解",
      "subtitle": "为您今日量身定制",
      "insightForYou": "给您的建议",
      "simpleActions": "您可以尝试的简单行动",
      "whenToSeekHelp": "何时需要寻求帮助",
      "nhsAdvice": "如有疑虑，请联系 NHS 111 或您的全科医生 (GP)",
      "backToDashboard": "返回个人看板",
      "newCheckIn": "开始新打卡",
      "disclaimer": "HealthLoop 提供健康指导，而非医疗诊断。"
    },
    "restDay": {
      "title": "休息也是生活节奏的一部分。",
      "body": "等您准备好了，我们明天再见。",
      "streakNote": "您的连续记录没有中断 —— 它也在和你一起休息呢。",
      "backToDashboard": "返回个人看板",
      "changedMind": "其实，我还是想打个卡。"
    },
    "feelings": {
      "title": "您今天感觉如何？",
      "hint": "选择所有适用项",
      "tired": "感到疲倦",
      "headache": "头痛",
      "stressed": "压力大或有些吃力",
      "pain": "身体酸痛或疼痛",
      "okay": "我今天感觉还可以"
    },
    "basics": {
      "title": "生活基础",
      "sleepQ": "昨晚睡得好吗？",
      "waterQ": "今天喝够水了吗？",
      "foodQ": "今天有好好吃饭吗？",
      "activityQ": "您今天的活动量如何？",
      "yes": "是的",
      "notReally": "不太好",
      "notYet": "还没有",
      "notActive": "没什么活动",
      "lightActivity": "轻量活动",
      "active": "活力十足"
    },
    "mind": {
      "title": "情绪与精力",
      "stressQ": "您今天的压力程度如何？",
      "moodQ": "您今天的心情怎么样？",
      "energyQ": "您今天的精力充沛吗？",
      "low": "偏低",
      "moderate": "适中",
      "high": "偏高",
      "neutral": "平常",
      "good": "挺好",
      "okay": "还好"
    },
    "day": {
      "title": "您的一天",
      "routineQ": "您今天遵循了平时的生活规律吗？",
      "yes": "是的",
      "no": "没有"
    },
    "environment": {
      "title": "今日环境",
      "describeQ": "您会如何描述身处的环境？",
      "comfortable": "😊 舒适",
      "slightlyUncomfortable": "😐 略有不适",
      "challenging": "😓 感到吃力",
      "affectedQ": "周围环境影响了您的感受吗？",
      "yes": "是的",
      "no": "没有",
      "exposureLabel": "环境接触（选择所有适用项）",
      "heat": "🌡️ 闷热",
      "cold": "❄️ 寒冷",
      "noise": "🔊 噪音",
      "dustSmoke": "💨 灰尘或烟雾",
      "crowded": "👥 拥挤空间",
      "none": "✅ 无"
    },
    "submit": {
      "analyzing": "正在分析您的健康趋势...",
      "cta": "查看我的健康见解"
    },
    "toast": {
      "savedFull": "打卡成功！您的看板已更新。",
      "savedShort": "打卡已保存。"
    }
  },
  "onboarding": {
    "welcome": "Welcome",
    "completeSetup": "Complete Setup",
    "stepProgress": "Step {{step}} of {{total}}",
    "percentComplete": "{{percent}}% complete",
    "welcomeToast": "Welcome to HealthLoop! Your profile is set up.",
    "errorAgeRange": "Please select your age range",
    "errorCountry": "Please select your country",
    "errorGoal": "Please select your primary health goal",
    "errorCuisine": "Please select at least one cuisine preference",
    "errorGeneric": "Failed to complete onboarding. Please try again.",
    "step1Title": "Welcome to HealthLoop! 👋",
    "step1Subtitle": "Let's personalize your health journey",
    "ageRangeLabel": "What's your age range?",
    "genderLabel": "Gender (Optional)",
    "gender_male": "Male",
    "gender_female": "Female",
    "gender_non-binary": "Non-binary",
    "gender_prefer_not_to_say": "Prefer not to say",
    "step2Title": "Where are you based? 🌍",
    "step2Subtitle": "This helps us recommend culturally relevant meals",
    "countryLabel": "Select your country",
    "country_uk": "United Kingdom",
    "country_nigeria": "Nigeria",
    "country_ghana": "Ghana",
    "country_kenya": "Kenya",
    "country_south_africa": "South Africa",
    "country_usa": "United States",
    "country_canada": "Canada",
    "country_india": "India",
    "country_jamaica": "Jamaica",
    "country_other": "Other",
    "step3Title": "What's your main goal? 🎯",
    "step3Subtitle": "Choose your primary health objective",
    "additionalGoals": "Any other goals? (Optional)",
    "goal_weight_loss": "Weight Loss",
    "goalDesc_weight_loss": "Lose weight healthily",
    "goal_weight_maintenance": "Maintain Weight",
    "goalDesc_weight_maintenance": "Stay at current weight",
    "goal_muscle_gain": "Build Muscle",
    "goalDesc_muscle_gain": "Gain strength & muscle",
    "goal_general_wellness": "General Wellness",
    "goalDesc_general_wellness": "Overall health improvement",
    "goal_better_sleep": "Better Sleep",
    "goalDesc_better_sleep": "Improve sleep quality",
    "goal_reduce_stress": "Reduce Stress",
    "goalDesc_reduce_stress": "Manage stress better",
    "goal_increase_energy": "More Energy",
    "goalDesc_increase_energy": "Feel more energized",
    "step4Title": "Food preferences 🍽️",
    "step4Subtitle": "Select cuisines you enjoy and any dietary restrictions",
    "cuisineLabel": "Preferred Cuisines",
    "cuisineHint": "Select at least one (you can choose multiple)",
    "dietaryLabel": "Dietary Restrictions (Optional)",
    "diet_vegetarian": "Vegetarian",
    "diet_vegan": "Vegan",
    "diet_halal": "Halal",
    "diet_kosher": "Kosher",
    "diet_gluten_free": "Gluten-Free",
    "diet_dairy_free": "Dairy-Free",
    "diet_pescatarian": "Pescatarian",
    "step5Title": "Health conditions 🏥",
    "step5Subtitle": "Optional — helps us provide better recommendations",
    "conditionsLabel": "Do you have any of these conditions?",
    "conditionsHint": "This information is private and helps personalize your experience",
    "condition_diabetes": "Diabetes",
    "condition_hypertension": "High Blood Pressure",
    "condition_heart_disease": "Heart Disease",
    "condition_thyroid": "Thyroid Issues",
    "condition_celiac": "Celiac Disease",
    "condition_ibs": "IBS",
    "condition_none": "None",
    "privacyTitle": "Your data is protected",
    "privacyBody": "Your personal information is encrypted and stored securely. We use this data only to personalise your experience with tailored meal recommendations, health tips, and notifications. Your data will never be shared with third parties without your explicit consent.",
    "trackMedication": "I want to track my medications",
    "specialistInterest": "I'm interested in specialist consultations",
    "welcomeTitle": "欢迎来到 HealthLoop! 👋",
    "welcomeSubtitle": "只需简单几步，让我们为您开启个性化的 AI 预防性健康与生活智能之旅",
    "stepLabel": "第 {{current}} 步，共 {{total}} 步",
    "skipForNow": "稍后进行",
    "skipToast": "您随时可以在个人资料中完成设置",
    "back": "返回",
    "next": "下一步",
    "completing": "正在完成...",
    "complete": "完成设置",
    "successToast": "欢迎加入 HealthLoop！您的个人偏好已设置完成 🎉",
    "failureToast": "无法完成设置",
    "validation": {
      "basicInfo": "请填写所有基本信息",
      "pickGoal": "请至少选择一个健康目标",
      "pickPrimary": "请选择您的首要目标",
      "pickRegion": "请选择您的文化区域，以便我们提供个性化的饮食建议",
      "pickFocus": "请选择您的主要身心健康重点"
    },
    "step1": {
      "title": "您的健康资料",
      "description": "帮助我们构建您的个性化 AI 健康情报",
      "age": "年龄 *",
      "agePlaceholder": "例如：30",
      "height": "身高 (cm) *",
      "heightPlaceholder": "例如：170",
      "weight": "体重 (kg) *",
      "weightPlaceholder": "例如：70"
    },
    "step2": {
      "title": "您的健康目标",
      "description": "请选择所有适用的选项，然后选出您的首要目标",
      "primaryLabel": "选择您的首要目标 *",
      "primaryBadge": "首要"
    },
    "step3": {
      "title": "🌍 文化与饮食偏好",
      "description": "帮助我们为您推荐更贴心的饮食方案",
      "regionLabel": "文化区域 *",
      "regionHint": "选择您的文化背景，以获得个性化的餐食建议",
      "countryLabel": "国家（可选）",
      "countryPlaceholder": "例如：尼日利亚、肯尼亚、牙买加",
      "countryHint": "提供此信息可获得更精准的建议",
      "foodPrefLabel": "饮食多样性偏好"
    },
    "step4": {
      "title": "主要身心健康重点",
      "description": "选择您最想关注的领域"
    },
    "step5": {
      "title": "您的个人偏好",
      "description": "定制您的 HealthLoop 体验",
      "trackMeds": "管理日常提醒",
      "trackMedsHint": "在每日记录中开启提醒功能，保持良好的健康习惯",
      "specialist": "对专家支持感兴趣",
      "specialistHint": "获取健康专家、营养师和心理健康专业人士的指导",
      "confidentialTitle": "隐私保护：",
      "confidentialBody": "您的所有信息均受保护，仅用于提供个性化的预防性健康洞察。"
    },
    "step6": {
      "title": "餐食个性化",
      "description": "帮助我们推荐符合您口味和营养需求的餐食",
      "cuisinesLabel": "偏好的菜系（可选）",
      "cuisinesHint": "选择您最喜欢的口味",
      "dietaryLabel": "饮食限制（可选）",
      "dietaryHint": "选择任何适用于您的选项",
      "allergiesLabel": "过敏原（可选）",
      "allergiesHint": "选择您的食物过敏项",
      "personalisedTitle": "个性化餐食：",
      "personalisedBody": "我们将根据这些偏好推荐符合您口味和健康需求的餐食。您随时可以在设置中更新这些内容。"
    },
    "healthGoals": {
      "better_sleep": "改善睡眠",
      "reduce_stress": "减轻压力",
      "increase_energy": "提升活力",
      "weight_management": "体重管理",
      "improve_fitness": "增强体适能",
      "better_nutrition": "优化营养",
      "mental_wellness": "心理健康",
      "chronic_condition": "管理身体状况"
    },
    "wellnessFocus": {
      "mental_health": {
        "label": "情绪平衡",
        "description": "关注情绪、压力和心理健康"
      },
      "physical_fitness": {
        "label": "身体活力",
        "description": "关注运动、力量和日常活动"
      },
      "nutrition": {
        "label": "营养饮食",
        "description": "关注饮食结构、餐食和健康饮食"
      },
      "sleep": {
        "label": "睡眠质量",
        "description": "关注休息、睡眠规律和体能恢复"
      },
      "stress_management": {
        "label": "压力调适",
        "description": "关注身心放松和缓解压力"
      }
    },
    "culturalRegions": {
      "west_african": {
        "label": "西非",
        "description": "尼日利亚、加纳、塞内加尔风味"
      },
      "east_african": {
        "label": "东非",
        "description": "肯尼亚、埃塞俄比亚、坦桑尼亚风味"
      },
      "north_african": {
        "label": "北非",
        "description": "摩洛哥、埃及风味"
      },
      "southern_african": {
        "label": "南部非洲",
        "description": "南非风味"
      },
      "caribbean": {
        "label": "加勒比地区",
        "description": "牙买加、特立尼达、巴巴多斯风味"
      },
      "middle_eastern": {
        "label": "中东",
        "description": "黎巴嫩、巴勒斯坦、叙利亚风味"
      },
      "south_asian": {
        "label": "南亚",
        "description": "印度、巴基斯坦、孟加拉国风味"
      },
      "east_asian": {
        "label": "东亚",
        "description": "中国、日本、韩国风味"
      },
      "southeast_asian": {
        "label": "东南亚",
        "description": "泰国、越南、印度尼西亚风味"
      },
      "western": {
        "label": "西方",
        "description": "美国、欧洲风味"
      },
      "latin_american": {
        "label": "拉丁美洲",
        "description": "墨西哥、巴西、阿根廷风味"
      },
      "mediterranean": {
        "label": "地中海",
        "description": "希腊、意大利、西班牙风味"
      }
    },
    "foodPreferences": {
      "traditional": {
        "label": "传统风格",
        "description": "主要推荐您所在文化区域的餐食"
      },
      "mixed": {
        "label": "融合风格",
        "description": "兼顾本土与国际风味"
      },
      "international": {
        "label": "国际风格",
        "description": "探索多元化的全球美食"
      }
    },
    "cuisines": {
      "west_african": "西非菜系",
      "caribbean": "加勒比菜系",
      "mediterranean": "地中海菜系",
      "asian": "亚洲菜系",
      "western": "西方菜系",
      "indian": "印度菜系",
      "middle_eastern": "中东菜系",
      "general": "所有菜系"
    },
    "dietary": {
      "vegetarian": "素食",
      "vegan": "纯素食",
      "pescatarian": "鱼素",
      "gluten_free": "无麸质",
      "dairy_free": "无乳制品",
      "low_carb": "低碳水"
    },
    "allergies": {
      "nuts": "坚果",
      "shellfish": "甲壳类",
      "dairy": "乳制品",
      "eggs": "蛋类",
      "soy": "大豆",
      "gluten": "麸质"
    },
    "cuisine_nigerian": "尼日利亚菜",
    "cuisine_ghanaian": "加纳菜",
    "cuisine_senegalese": "塞内加尔菜",
    "cuisine_kenyan": "肯尼亚菜",
    "cuisine_ethiopian": "埃塞俄比亚菜",
    "cuisine_moroccan": "摩洛哥菜",
    "cuisine_south_african": "南非菜",
    "cuisine_jamaican": "牙买加菜",
    "cuisine_trinidadian": "特立尼达菜",
    "cuisine_lebanese": "黎巴嫩菜",
    "cuisine_turkish": "土耳其菜",
    "cuisine_greek": "希腊菜",
    "cuisine_italian": "意大利菜",
    "cuisine_french": "法国菜",
    "cuisine_british": "英国菜",
    "cuisine_indian_south": "南印度菜",
    "cuisine_indian_north": "北印度菜",
    "cuisine_pakistani": "巴基斯坦菜",
    "cuisine_japanese": "日本料理",
    "cuisine_chinese": "中餐",
    "cuisine_korean": "韩餐",
    "cuisine_vietnamese": "越南菜",
    "cuisine_thai": "泰餐",
    "cuisine_filipino": "菲律宾菜",
    "cuisine_american": "美式料理",
    "cuisine_mexican": "墨西哥菜",
    "cuisine_brazilian": "巴西菜",
    "cuisine_peruvian": "秘鲁菜"
  },
  "dashboard": {
    "welcome": "欢迎回来",
    "greeting": "Hello",
    "goodMorning": "早上好",
    "goodAfternoon": "下午好",
    "goodEvening": "晚上好",
    "tagline": "微小的健康步伐成就持久的改变",
    "microcopy": "Your wellness journey matters.",
    "welcomeSubtitleMorning1": "A calm start to the day.",
    "welcomeSubtitleMorning2": "Glad you stopped by this morning.",
    "welcomeSubtitleMorning3": "Small moments add up.",
    "welcomeSubtitleAfternoon1": "Hope your day feels steady.",
    "welcomeSubtitleAfternoon2": "Welcome back to HealthLoop.",
    "welcomeSubtitleAfternoon3": "Take a breath — you're doing well.",
    "welcomeSubtitleEvening1": "Winding down with you.",
    "welcomeSubtitleEvening2": "A gentle close to the day.",
    "welcomeSubtitleEvening3": "Welcome back this evening.",
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate",
    "summary": "Your Health Intelligence Summary",
    "summaryDesc": "Real-time insights across prevention, education, engagement, and wellness",
    "comprehensiveSupport": "Comprehensive support across prevention, education, engagement, and wellness",
    "todayCheckIn": "今日签到",
    "quickActions": "快捷操作",
    "healthOverview": "Health Overview",
    "recentActivity": "Recent Activity",
    "viewAll": "查看全部",
    "preventiveHealth": "Preventive Health",
    "preventiveHealthDesc": "Daily tracking, wellness monitoring & preventive alerts",
    "education": "Education",
    "educationDesc": "Evidence-based insights, health articles & expert guidance",
    "engagement": "Engagement",
    "engagementDesc": "Community challenges, habit tracking & social support",
    "wellness": "Wellness",
    "wellnessDesc": "Smart nutrition, lifestyle balance & holistic well-being",
    "todaysInsight": "Today's Insight",
    "wellnessScore": "Wellness Score",
    "healthStreak": "Health Streak",
    "days": "天",
    "logHealth": "Log Health",
    "getEducated": "Get Educated",
    "communityChallenge": "Community Challenge",
    "checkWellness": "Check Wellness",
    "verified": "Verified",
    "joinCommunity": "Join Community",
    "personalizedPlan": "Personalized Plan",
    "score": "Score",
    "checkIns": "check-ins",
    "habits": "habits",
    "preventive": "Preventive",
    "healthMetrics": "Health Metrics",
    "trackMetrics": "Track Metrics",
    "startTracking": "Start tracking",
    "logMetrics": "Log Metrics",
    "dailyInsight": "Daily Insight",
    "learnAbout": "Learn about preventive health today",
    "articlesAvailable": "articles available",
    "browseArticles": "Browse Articles",
    "currentStreak": "Current Streak",
    "keepGoing": "Keep it going!",
    "startStreak": "Start your streak",
    "checkIn": "Check In",
    "nutritionPlan": "Nutrition Plan",
    "mealsPlanned": "meals planned",
    "viewPlan": "View Plan",
    "planYourWeek": "Plan your week",
    "moodStress": "Mood & Stress",
    "howFeeling": "How are you feeling?",
    "logWellness": "Log Wellness",
    "medications": "Medications",
    "noMeds": "No meds tracked",
    "addMedications": "Add your medications",
    "daysTracked": "Days Tracked",
    "noHabits": "No habits yet",
    "startTrackingHabits": "Start tracking habits",
    "insights": "Insights",
    "noInsights": "No insights yet",
    "completeFirstPlan": "Complete your first plan",
    "noCheckIns": "No check-ins yet",
    "startFirstCheckIn": "Start your first check-in"
  },
  "support": {
    "title": "支持",
    "subtitle": "查找答案、联系我们或反馈问题",
    "backToSettings": "返回设置",
    "privacyBanner": "Support requests are handled privately and securely. Your health information stays confidential.",
    "section1": "Section 1",
    "section2": "Section 2",
    "section3": "Section 3",
    "section4": "Section 4",
    "navHelpCenter": "Help Center",
    "navContact": "Contact Support",
    "navHealth": "Health Services",
    "navTechnical": "Technical Support",
    "helpCenterTitle": "Help Center",
    "helpCenterSubtitle": "Search common questions and find quick answers.",
    "contactTitle": "Contact Support",
    "contactSubtitle": "Reach our team through your preferred channel.",
    "healthServicesTitle": "Health Services",
    "healthServicesSubtitle": "Connect with medication tracking and clinical experts.",
    "technicalTitle": "Technical Support",
    "technicalSubtitle": "Report bugs or technical issues with detailed context.",
    "searchPlaceholder": "Search common questions…",
    "liveChat": "Live Chat",
    "emailUs": "Email Us",
    "callBack": "Schedule a callback",
    "sendMessage": "Send a message",
    "medicationTracking": "Medication tracking",
    "specialistAccess": "Specialist access",
    "videoConsultation": "Video consultation",
    "reportBug": "Report a bug",
    "yourName": "Your name",
    "yourEmail": "Your email",
    "subject": "Subject",
    "message": "Message",
    "phone": "Phone",
    "description": "Description",
    "submit": "Submit",
    "successTitle": "Message sent",
    "successDescription": "We'll reply within 24–48 hours.",
    "healthDisclaimer": "For medical emergencies, contact local emergency services. HealthLoop is not a substitute for professional medical care."
  },
  "nutrition": {
    "smartNutrition": "Smart Nutrition",
    "basedOnGoal": "Based on your goal:",
    "personalizedData": "Personalized based on your recent health data",
    "evidenceBased": "Evidence-based nutrition as part of your preventive health plan",
    "todaysMealSuggestions": "Today's Meal Suggestions",
    "customize": "Customize",
    "breakfast": "Breakfast",
    "lunch": "Lunch",
    "dinner": "Dinner",
    "loadingBreakfast": "Loading breakfast...",
    "loadingLunch": "Loading lunch...",
    "loadingDinner": "Loading dinner...",
    "cal": "cal",
    "protein": "protein",
    "swapMeal": "Swap Meal",
    "healthyOptionsNearYou": "Healthy Options Near You",
    "enableLocation": "Enable location",
    "view": "View",
    "discoverOptions": "Discover healthy restaurants, grocery stores, and meal prep vendors near you",
    "cuisinesSelected": "cuisines selected",
    "cuisineSelected": "cuisine selected",
    "dietaryPrefs": "dietary prefs",
    "dietaryPref": "dietary pref",
    "customizeMeals": "Customize meals to match your cultural preferences and dietary needs",
    "subtitleAdaptive": "Culturally adaptive, personalized meal planning for your health goals",
    "hideFavorites": "Hide Favorites",
    "viewFavorites": "View Favorites",
    "customizeMealsLegacy": "Customize meals to match your cultural preferences and dietary needs",
    "viewFullPlan": "View Full Plan",
    "exploreRecipes": "Explore Recipes"
  },
  "location": {
    "permissionTitle": "Find healthy options near you",
    "permissionDesc": "Used to recommend restaurants, grocery stores, and meal prep vendors aligned with your health goals.",
    "howToEnable": "How to enable:",
    "step1": "Click the lock icon 🔒 in your browser's address bar",
    "step2": "Find \"Location\" permissions",
    "step3": "Change to \"Allow\"",
    "step4": "Refresh this page",
    "refreshPage": "Refresh Page",
    "allowLocation": "Allow Location",
    "notNow": "Not now",
    "denied": "Location access was blocked. To see nearby healthy options, you'll need to enable location permissions.",
    "unavailable": "Location information is currently unavailable. Please check your device settings.",
    "error": "Unable to access your location. Please try again or check browser settings.",
    "unsupported": "Your browser doesn't support location services. Try using a modern browser like Chrome, Firefox, or Safari.",
    "accessRequired": "Location Access Required"
  },
  "womensHealth": {
    "title": "Women's Health",
    "description": "Track your cycle, log symptoms, and get personalized wellness tips based on your cycle phase",
    "cycleTracking": "Cycle Tracking",
    "symptomLogging": "Symptom Logging",
    "phaseInsights": "Phase Insights",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Insights",
    "tips": "Health Tips",
    "overview": "Overview",
    "history": "History",
    "startTracking": "Start Tracking Your Cycle"
  },
  "profile": {
    "title": "个人资料",
    "personalInfo": "Personal Information",
    "healthProfile": "Health Profile",
    "preferences": "Preferences",
    "language": "Language",
    "selectLanguage": "Select Language",
    "notifications": "Notifications",
    "privacy": "Privacy",
    "security": "Security",
    "quickAccess": "Quick Access",
    "editProfile": "编辑资料",
    "viewStats": "View Stats",
    "backToDashboard": "返回仪表盘",
    "womensHealthTitle": "Women's Health",
    "womensHealthDesc": "Cycle tracking, symptoms & wellness tips",
    "healthRemindersTitle": "Health Reminders",
    "healthRemindersDesc": "Manage your notifications",
    "manageRemindersDesc": "Manage your reminder preferences and notifications",
    "healthPatternAlerts": "Your Health Pattern Alerts",
    "supportHelp": "Support & Help",
    "supportHelpDesc": "Get assistance, report issues, or browse FAQs",
    "admin": "Admin",
    "adminDesc": "View usage metrics and user behavior insights",
    "giveFeedback": "Give Feedback",
    "giveFeedbackDesc": "Share your experience with HealthLoop",
    "reportProblem": "Report a Problem",
    "reportProblemDesc": "Help us fix bugs and improve the app",
    "manageHealthInfo": "Manage your preventive health information for personalized insights",
    "basicInformation": "Basic Information",
    "fullName": "Full Name",
    "email": "Email",
    "dateOfBirth": "Date of Birth",
    "gender": "Gender",
    "height": "Height (cm)",
    "weight": "Weight (kg)",
    "medicalConditions": "Medical Conditions",
    "allergies": "Allergies",
    "personalHealth": "Personal Health",
    "addCondition": "Add a medical condition",
    "addAllergy": "Add an allergy",
    "saveChanges": "Save Changes",
    "saving": "Saving...",
    "privacyMessage": "Your health data is protected with confidential care standards"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "account": "Account",
    "appearance": "Appearance",
    "languageSettings": "Language Settings",
    "changeLanguage": "Change Language",
    "languageNote": "界面会在您选择新语言后立即更新。非洲语言和新添加的语言标记为“初始版”——为扩大覆盖范围而采用机器翻译，正等待母语人士的质量审核。",
    "languageUpdated": "Language updated successfully",
    "starterBadge": "初始版",
    "starterBadgeTooltip": "机器翻译——母语审核中。",
    "regions": {
      "global": "全球",
      "european": "欧洲语言",
      "middleEastern": "中东语言",
      "asian": "亚洲语言",
      "african": "非洲语言"
    }
  },
  "search": {
    "triggerLabel": "搜索 HealthLoop",
    "triggerHint": "尝试“步数”、“药房”或“孕期”",
    "triggerAriaLabel": "打开全局搜索",
    "placeholder": "搜索功能、记录工具、支持...",
    "inputAriaLabel": "搜索 HealthLoop 功能",
    "modalAriaLabel": "搜索 HealthLoop",
    "close": "关闭",
    "clear": "清除",
    "clearAriaLabel": "清除搜索内容",
    "recentSearches": "最近搜索",
    "tryFor": "您可以搜索",
    "findFeatures": "数秒内找到任何功能。",
    "searchAcross": "搜索范围涵盖",
    "and": "及",
    "sections": {
      "home": "首页",
      "nutrition": "营养",
      "family": "家庭",
      "services": "服务",
      "support": "支持",
      "profile": "个人资料"
    },
    "noMatchesFor": "未找到与“{{query}}”匹配的内容",
    "trySimpler": "尝试使用更简单的词汇，如“步数”、“营养”或“专家”。",
    "comingSoonBadge": "即将推出",
    "escToClose": "关闭",
    "resultSingular": "{{count}} 条结果",
    "resultPlural": "{{count}} 条结果",
    "searchAcrossApp": "在整个应用中搜索"
  },
  "familyMember": {
    "confirmRemove": "是否停止对 {{name}} 的家庭健康监测？",
    "removed": "已将 {{name}} 从家庭成员中移除",
    "removeFailed": "移除成员失败",
    "viewDetails": "查看详情",
    "edit": "编辑",
    "remove": "移除",
    "yearsSuffix": "岁",
    "healthGoalsLabel": "健康目标：",
    "moreSuffix": "更多",
    "activeInsights": "当前健康洞察",
    "viewAllInsights": "查看全部 {{count}} 条洞察 →",
    "viewFullProfile": "查看完整健康档案",
    "lifeStage": {
      "infant": "婴儿 (0-2岁)",
      "toddler": "幼儿 (2-5岁)",
      "child": "儿童 (6-12岁)",
      "adolescent": "青少年 (13-17岁)",
      "adult": "成年 (18-59岁)",
      "senior": "老年 (60岁+)",
      "unknown": "未知"
    }
  },
  "profileDeep": {
    "backToDashboard": "返回仪表盘",
    "profileCompletion": "资料完整度",
    "healthSummary": "健康摘要",
    "sectionA": "区块 A",
    "sectionB": "区块 B",
    "sectionC": "区块 C",
    "sectionD": "区块 D",
    "personalDetails": "个人信息",
    "healthInformation": "健康信息",
    "accountSettings": "账户设置",
    "fullName": "姓名",
    "email": "邮箱",
    "dob": "出生日期",
    "gender": "性别",
    "genderPlaceholder": "例如：女、男、非二元",
    "height": "身高 (cm)",
    "heightPlaceholder": "例如：170",
    "weight": "体重 (kg)",
    "weightPlaceholder": "例如：70",
    "allergies": "过敏",
    "allergiesPlaceholder": "例如：花生",
    "medicalConditions": "健康状况",
    "conditionsPlaceholder": "例如：高血压",
    "medications": "药物",
    "medicationsPlaceholder": "例如：赖诺普利 10mg，每日",
    "emergencyContact": "紧急联系人",
    "emergencyOptional": "（可选）",
    "emergencyPlaceholder": "例如：妈妈 +86-138-0000-0000",
    "emergencyNote": "仅在与临床医生分享时才会包含。",
    "saveChanges": "保存更改",
    "saving": "保存中…",
    "editProfile": "编辑资料",
    "cancelEditing": "取消编辑",
    "healthScore": "健康评分",
    "streak": "连续天数",
    "streakDays": "{{n}} 天",
    "memberSince": "加入时间",
    "remindersActive": "已启用提醒",
    "conditionsTracked": "跟踪中的健康状况",
    "nextAgenda": "日程中的下一项",
    "notificationsReminders": "通知与提醒",
    "notificationsRemindersDesc": "管理提醒时间和渠道",
    "emailNudges": "邮件提醒",
    "emailNudgesDesc": "温和的提醒和每周摘要",
    "on": "已开启",
    "paused": "已暂停",
    "privacySecurity": "隐私与安全",
    "privacySecurityDesc": "更新密码以保护账户安全",
    "preferencesTitle": "偏好设置",
    "preferencesDesc": "语言、地区和个性化",
    "supportHelp": "帮助与支持",
    "supportHelpDesc": "获取答案并联系我们",
    "giveFeedback": "提供反馈",
    "giveFeedbackDesc": "告诉我们如何改进",
    "reportProblem": "反馈问题",
    "reportProblemDesc": "发现错误？告诉我们",
    "adminInsights": "管理洞察",
    "adminInsightsDesc": "参与度分析",
    "adminBadge": "管理员",
    "shareWithClinician": "分享给临床医生",
    "shareWithClinicianDesc": "只读摘要 · 自动过期 · 随时可撤销",
    "share": "分享",
    "profileMayBeOutOfDate": "资料可能已过期",
    "profileMayBeOutOfDateDesc": "保持数据最新以获得更精准的建议 —— 体重、药物等小变化也很有帮助。",
    "updateNow": "立即更新",
    "profileUpdateError": "无法更新偏好设置。请稍后重试。",
    "healthLoopUser": "HealthLoop 用户",
    "updatedLabel": "更新于",
    "noEntries": "暂无记录。",
    "completionComplete": "您的资料已完成，我们可以为您提供最好的建议。💚",
    "completionAlmostThere": "快好了，再补充一些信息以获得更精准的建议。",
    "completionInProgress": "完善资料以获得更好的健康建议。",
    "justNow": "刚刚",
    "minAgo": "{{n}} 分钟前",
    "minsAgo": "{{n}} 分钟前",
    "hourAgo": "{{n}} 小时前",
    "hoursAgo": "{{n}} 小时前",
    "dayAgo": "{{n}} 天前",
    "daysAgo": "{{n}} 天前",
    "checkinDueToday": "今日签到待完成",
    "checkinDueTonight": "今晚签到待完成"
  },
  "supportDeep": {
    "backToSettings": "返回设置",
    "quickNavAria": "支持版块",
    "searchPlaceholder": "搜索帮助…",
    "searchAria": "搜索常见问题",
    "resultsCount": "{{n}} 条结果",
    "resultsCountPlural": "{{n}} 条结果",
    "questionsCount": "{{n}} 个问题",
    "liveChatTitle": "在线聊天",
    "liveChatDesc": "实时联系我们 · 周一至周五 9:00-18:00",
    "startChat": "开始聊天",
    "liveChatSoonToast": "在线聊天即将上线。在此之前，邮件同样高效。",
    "emailUsTitle": "邮件联系",
    "emailUsDesc": "24–48 小时内回复",
    "copy": "复制",
    "emailCopied": "邮箱已复制。",
    "contactFormTitle": "联系表单",
    "contactFormDesc": "给我们留言 —— 我们会通过邮件回复。",
    "yourNameLabel": "您的姓名 *",
    "namePlaceholder": "张三",
    "yourEmailLabel": "您的邮箱 *",
    "emailPlaceholder": "zhangsan@example.com",
    "subjectOptional": "主题（可选）",
    "subjectPlaceholder": "我们能帮您什么？",
    "messageLabel": "留言 *",
    "messagePlaceholder": "请简要描述您的需求。",
    "sending": "发送中…",
    "sendMessage": "发送消息",
    "messageSent": "消息已发送",
    "messageSentDesc": "我们将在 24–48 小时内回复。",
    "callbackTitle": "请求回拨",
    "callbackDesc": "我们会在您方便的时间回电。",
    "phoneLabel": "电话号码 *",
    "phonePlaceholder": "+86 138 0000 0000",
    "preferredTimeLabel": "偏好时间（可选）",
    "preferredTimePlaceholder": "例如：明天下午",
    "reasonLabel": "原因（可选）",
    "reasonPlaceholder": "简要说明您想讨论的内容？",
    "submitting": "提交中…",
    "requestCallback": "请求回拨",
    "callbackRequested": "回拨已请求",
    "callbackRequestedDesc": "我们将在 24 小时内联系您。",
    "medicationSupport": "药物支持",
    "medicationSupportDesc": "跟踪处方、续配与提醒。",
    "goToMedications": "前往药物 →",
    "specialistConsultation": "专科咨询",
    "specialistConsultationDesc": "与临床医生联系，获取个性化健康指导。",
    "connectExpert": "联系专家 →",
    "videoConsult": "视频咨询",
    "videoConsultDesc": "与专科医生预约视频会诊。",
    "bookConsultation": "预约咨询 →",
    "premium": "高级",
    "healthDisclaimer": "HealthLoop 支持您的日常健康管理 —— 不能替代紧急医疗护理。紧急情况请联系当地紧急服务。",
    "categoryLabel": "类别",
    "catBug": "错误 / Bug",
    "catPerformance": "性能缓慢",
    "catFeature": "功能异常",
    "catUi": "显示问题",
    "catOther": "其他",
    "issueTitle": "问题标题 *",
    "issueTitlePlaceholder": "简要摘要",
    "detailedDescription": "详细描述 *",
    "detailedDescriptionPlaceholder": "发生了什么？您在做什么？复现步骤对我们帮助很大。",
    "autoAttachNote": "设备、浏览器和视口信息将自动附加。",
    "submitReport": "提交报告",
    "reportSubmitted": "报告已提交",
    "reportSubmittedDesc": "我们的团队正在处理。",
    "fillAllFields": "请填写所有必填字段",
    "problemReportSubmittedToast": "问题报告已收到。我们会调查并尽快回复您。",
    "messageSentToast": "消息已发送。我们将在 24–48 小时内回复。",
    "callRequestedToast": "回拨请求已收到。我们将在 24 小时内联系您。",
    "submitFailGeneric": "提交失败。请重试或发邮件至 {{email}}。",
    "submitFailContact": "发送失败。请直接发邮件至 {{email}}。"
  },
  "careServices": {
    "pageTitle": "Care Services",
    "pageSubtitle": "Clinical and wellness support designed for your everyday health journey.",
    "specialistCareTitle": "Specialist Care",
    "specialistCareSubtitle": "Talk to clinicians and book the right specialist when you need one.",
    "medicationPharmacyTitle": "Medication & Pharmacy",
    "medicationPharmacySubtitle": "Plain-language medication guidance and pharmacy help.",
    "wellnessSupportTitle": "Wellness Support",
    "wellnessSupportSubtitle": "Mental wellness, over-the-counter guidance, and a clear next-step path.",
    "futureWellnessTitle": "Future Wellness Features",
    "futureWellnessSubtitle": "A preview of what's on HealthLoop's preventive-wellness roadmap.",
    "futureFeatureBadge": "Future Feature",
    "futurePersonalizedMealsTitle": "Personalized Meal Plans",
    "futurePersonalizedMealsDesc": "Wellness-led meal plans tuned to your goals, allergies, and culture.",
    "futureHealthyDeliveryTitle": "Healthy Meal Delivery",
    "futureHealthyDeliveryDesc": "Curated delivery from health-conscious kitchens and partners.",
    "futureFarmFreshTitle": "Farm-Fresh Wellness Foods",
    "futureFarmFreshDesc": "Direct access to local farms and seasonal fresh-produce partners.",
    "futureFoodPartnershipsTitle": "Wellness Food Partnerships",
    "futureFoodPartnershipsDesc": "Curated relationships with healthy kitchens, grocers, and wellness brands.",
    "futureNutritionCoachingTitle": "Nutrition Coaching",
    "futureNutritionCoachingDesc": "One-to-one guidance from credentialed nutrition coaches.",
    "futureFamilyWellnessTitle": "Family Wellness Plans",
    "futureFamilyWellnessDesc": "Shared plans that keep the whole household on track.",
    "futureWellnessPlusTitle": "Wellness+ Membership",
    "futureWellnessPlusDesc": "A premium tier for personalised guidance, priority support, and deeper insights.",
    "futurePharmacyPartnersTitle": "Pharmacy Partnerships",
    "futurePharmacyPartnersDesc": "Trusted pharmacy connections for medication guidance and refills.",
    "futureAdvancedSpecialistTitle": "Advanced Specialist Care",
    "futureAdvancedSpecialistDesc": "Coordinated access to specialists, second opinions, and care navigation.",
    "futureWellnessMarketplaceTitle": "Wellness Marketplace",
    "futureWellnessMarketplaceDesc": "A curated marketplace of vetted wellness products and services.",
    "futureVendorCollabTitle": "Vendor Collaboration Systems",
    "futureVendorCollabDesc": "Onboarding and quality systems for healthy food and wellness partners."
  },
  "dashboardDeep": {
    "healthProfile": "健康档案",
    "notifications": "通知",
    "familyAccounts": "家庭账户",
    "settings": "设置",
    "logout": "退出登录",
    "allCaughtUp": "一切都已处理完毕。",
    "weekInReview": "您的本周回顾",
    "dismissNotification": "关闭通知",
    "dismissWeeklyDigest": "关闭周报",
    "notificationsAria": "通知",
    "profileMenuAria": "打开账户菜单",
    "loadingWellness": "正在加载您的健康摘要",
    "nextTip": "下一条提示",
    "todayAtGlance": "今日概览",
    "healthScoreLabel": "健康评分",
    "currentStreakLabel": "当前连续",
    "todaysProgress": "今日进度",
    "insightForYou": "为您提供的洞察",
    "checkMyHealthRisk": "检查我的健康风险",
    "quickAccess": "快捷入口",
    "familyCare": "家庭关怀",
    "healthLibrary": "健康知识库",
    "myHealthData": "我的健康数据",
    "askQuestion": "提问",
    "dashLoadError": "无法加载仪表盘。请重试。",
    "taskUpdateError": "无法更新任务。请重试。",
    "perfectDay": "完美的一天！🎉 连续天数已延长。",
    "letsStart": "开始吧",
    "yourNextStepToday": "今天的下一步",
    "completeDailyCheck": "完成今日健康签到",
    "startDailyCheck": "开始今日签到",
    "viewAll": "查看全部",
    "graceProtected": "宽限期保护",
    "todaysHealthRecommendations": "今日健康建议",
    "updateViaCheck": "通过今日签到更新",
    "healthInsight": "健康洞察",
    "riskCheckSubtext": "几秒内获取个性化健康洞察",
    "foodDiet": "饮食",
    "healthScoreNew": "健康评分 · 新",
    "letsBuildScore": "让我们一起构建您的健康评分",
    "oneHealthyHabitAtATime": "一次养成一个健康习惯。",
    "nextCheck": "下次签到：",
    "todayAt8pm": "今晚 8:00",
    "wellnessTipForYou": "今日健康提示 · 为您",
    "wellnessTipForFactor": "今日健康提示 · 为您的 {{factor}}",
    "logged": "已记录",
    "gotIt": "明白了 👍",
    "gladToSeeYou": "很高兴今天见到您 💚",
    "takesLessThan60Sec": "不到 60 秒",
    "scoreReadyWhenYou": "随时为您准备",
    "scoreCompleteFirstCheck": "完成第一次健康签到，解锁个性化建议。",
    "scoreExcellent": "出色",
    "scoreSupportExcellent": "今天状态很棒，继续保持！",
    "scoreGood": "良好",
    "scoreSupportGood": "做得不错，保持您的健康习惯。",
    "scoreModerate": "一般",
    "scoreSupportModerate": "总体不错，但有些方面需要关注。",
    "scoreNeedsAttention": "需要关注",
    "scoreSupportNeedsAttention": "您的健康今天需要关注。小改变也能带来不同。"
  },
  "emailVerify": {
    "bannerWithEmail": "请验证您的邮箱 ({{email}})，以便我们保护您的账户并发送每日提醒。",
    "bannerNoEmail": "请验证您的邮箱，以便我们保护您的账户并发送每日提醒。",
    "sending": "发送中…",
    "resend": "重新发送",
    "sentToast": "验证邮件已发送，请查收。",
    "sendFailToast": "无法发送验证邮件，请稍后再试。"
  },
  "forgotPassword": {
    "title": "忘记密码？",
    "subtitle": "别担心！输入您的邮箱，我们会发送重置说明。",
    "emailLabel": "邮箱地址",
    "emailPlaceholder": "your.email@example.com",
    "sendResetLink": "发送重置链接",
    "sending": "发送中…",
    "backToLogin": "返回登录",
    "resendLink": "重新发送邮件",
    "successTitle": "请查收邮件",
    "successBody": "如果存在 {{email}} 的账户，我们已发送密码重置链接。",
    "linkExpires": "链接将在 30 分钟后过期。",
    "successToast": "请查收邮件，按说明操作",
    "errEmptyEmail": "请输入您的邮箱",
    "errInvalidEmail": "请输入有效的邮箱",
    "errNetwork": "无法连接服务器，请检查网络后重试。",
    "errGeneric": "发送失败，请重试或联系支持。"
  },
  "resetPassword": {
    "title": "设置新密码",
    "subtitle": "为您的账户创建一个强密码",
    "newPasswordLabel": "新密码",
    "newPasswordPlaceholder": "输入新密码",
    "confirmPasswordLabel": "确认密码",
    "confirmPasswordPlaceholder": "确认新密码",
    "requirementsHint": "至少 8 位，包含大写、小写字母和数字",
    "resetPassword": "重置密码",
    "resetting": "重置中…",
    "successTitle": "密码重置成功！",
    "successBody": "您可以使用新密码登录了。",
    "successToast": "密码已成功重置！",
    "goToLogin": "去登录",
    "invalidLinkTitle": "链接无效",
    "invalidLinkBody": "此重置链接无效或已过期。",
    "requestNewLink": "请求新链接",
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "errInvalidLink": "重置链接无效",
    "errMismatch": "两次密码不一致",
    "errTooShort": "密码至少需 8 个字符",
    "errExpiredToken": "此链接已过期或无效，请请求新链接。",
    "errNetwork": "无法连接服务器，请检查网络。",
    "errGeneric": "重置失败，请重试。"
  },
  "tips": {
    "water1": "醒来 30 分钟内喝水有助于改善水分和精力水平。",
    "water2": "每餐前一杯水，是温和地领先于口渴的好方法。",
    "water3": "加片柠檬或几片薄荷叶，让喝水变得像享受。",
    "meals1": "每天多加一份蔬菜，有助于肠道与心脏健康。",
    "meals2": "早餐搭配一小把坚果或种子，让上午精力更稳定。",
    "meals3": "整颗水果胜过果汁——纤维让血糖更平稳。",
    "steps1": "饭后散步 10 分钟，有助身体更温和地处理糖分。",
    "steps2": "早晨 5 分钟拉伸可缓解紧张，为一天定下平静基调。",
    "steps3": "每天走一次楼梯，几周下来悄悄强健心脏。",
    "sleep1": "睡前一小时调暗灯光，有助身体放松，进入更深的睡眠。",
    "sleep2": "固定的起床时间——周末也一样——让睡眠周期更稳定。",
    "sleep3": "早晨 10 分钟阳光有助自然调节您的睡眠节律。",
    "general1": "两分钟慢呼吸，可降低压力、稳定专注。",
    "general2": "今天留意一个感恩的瞬间——小小的心理胜利也会累积。",
    "general3": "您今天出现了。这是让其他所有习惯都更容易的习惯。"
  },
  "factors": {
    "hydration": "补水",
    "nutrition": "营养",
    "movement": "活动",
    "sleep": "睡眠"
  },
  "nutritionDeep": {
    "mealOptionsLoadFail": "无法加载餐食选项",
    "prefsSaved": "饮食偏好已保存！正在刷新…",
    "prefsSaveFail": "保存偏好失败",
    "newOptionsFail": "无法加载新选项",
    "invalidZip": "请输入有效的 5 位邮政编码",
    "noVendorsArea": "该地区暂无供应商。我们正在扩展覆盖范围！",
    "vendorsFetchFail": "无法获取供应商",
    "selectVendorFirst": "请先选择配送供应商",
    "removedFromCart": "已从购物车移除",
    "orderPlaced": "下单成功！🎉",
    "enterZipFirst": "请先在配送区填写您的邮编",
    "mealNotAvailable": "此餐食暂不支持您所在地区配送",
    "mealUnavailable": "附近供应商当前未提供此餐食",
    "vendorOptionsFail": "无法加载供应商选项",
    "favoriteSaveFail": "收藏失败",
    "removedFromFavorites": "已从收藏移除",
    "favoriteRemoveFail": "取消收藏失败",
    "cartEmpty": "购物车为空",
    "noMealOptions": "暂无餐食选项",
    "loadingOptions": "正在加载餐食选项...",
    "selectPreferences": "选择您的饮食偏好",
    "mealBuilder": "搭配餐食",
    "myFavorites": "我的收藏",
    "myFavoriteMeals": "我喜欢的餐食",
    "noFavoritesYet": "还没有收藏的餐食！",
    "price": "价格",
    "delivery": "配送",
    "deliveryFee": "配送费",
    "distance": "距离",
    "subtotal": "小计",
    "total": "合计",
    "orderNumber": "订单号",
    "vendor": "供应商",
    "totalAmount": "总金额",
    "estimatedDelivery": "预计送达",
    "whyThisMeal": "为什么选这餐",
    "selectThisMeal": "选择此餐",
    "swapMeal": "更换餐食",
    "orderThisMeal": "下单此餐",
    "notAvailableNearYou": "您附近暂不可用",
    "tryAdjustingPrefs": "尝试调整饮食偏好以查看建议",
    "myMealPlanSummary": "我的餐食计划",
    "saveCompletePlan": "保存完整计划",
    "yourFoodPreferences": "您的饮食偏好",
    "editPreferences": "编辑偏好",
    "healthyMealDelivery": "健康餐配送",
    "enableDelivery": "启用配送",
    "enterZipCode": "输入您的邮政编码以查看可用餐食",
    "savePreferences": "保存偏好",
    "quickAccessSavedMeals": "快速访问您收藏的餐食",
    "saveMealsFromBuilder": "从“搭配餐食”标签保存餐食",
    "chooseVendor": "选择供应商下单此餐",
    "yourCart": "您的购物车",
    "addMealsToStart": "从下方选项添加餐食以开始",
    "orderPlacedDesc": "您的健康餐订单已成功下单",
    "continueShopping": "继续购物",
    "trackOrder": "追踪订单",
    "healthyStoresTitle": "附近的健康商店与健康市场",
    "healthyStoresIntro": "为您推荐周边具有文化特色的各类商店，仅供参考（非外送服务）。",
    "healthyStoresGuidanceTitle": "健康购物指南",
    "healthyStoresDisclaimer": "HealthLoop 仅提供一般性健康和购物灵感，不作为医疗或饮食治疗建议。",
    "healthyStores": {
      "organic": {
        "type": "有机食品店",
        "description": "提供新鲜、无农药的农产品和加工极少的厨房常备品。",
        "tags": [
          "天然食品",
          "新鲜农产品"
        ]
      },
      "farmers": {
        "type": "农夫集市",
        "description": "直接源自种植者的当地季节性水果、蔬菜和传统农产品。",
        "tags": [
          "本土",
          "时令"
        ]
      },
      "african": {
        "type": "非洲生鲜店",
        "description": "提供山药、大蕉、绿叶蔬菜、棕榈果及西非/东非主食。",
        "tags": [
          "文化特色",
          "新鲜农产品"
        ]
      },
      "caribbean": {
        "type": "加勒比天然食品市场",
        "description": "提供卡拉路蔬菜、木薯、苏格兰帽辣椒、西非荔枝果、面包果等海岛主食。",
        "tags": [
          "文化特色",
          "天然食品"
        ]
      },
      "asian": {
        "type": "亚洲蔬菜超市",
        "description": "提供小白菜、大白萝卜、莲藕、豆腐、新鲜香草及泛亚地区主食。",
        "tags": [
          "文化特色",
          "新鲜农产品"
        ]
      },
      "halal": {
        "type": "清真健康食品市场",
        "description": "经清真认证的瘦肉蛋白、新鲜农产品和传统香料。",
        "tags": [
          "清真",
          "文化特色"
        ]
      },
      "mediterranean": {
        "type": "地中海全食市场",
        "description": "橄榄油、豆类、新鲜香草、全谷物和地中海风格主食。",
        "tags": [
          "文化特色",
          "天然食品"
        ]
      },
      "wellness": {
        "type": "健康主题超市",
        "description": "精选全食、植物基食品和纯净标签库存商品。",
        "tags": [
          "天然食品",
          "植物基"
        ]
      }
    },
    "healthyShoppingTips": [
      "先逛外围区域：新鲜农产品、瘦肉蛋白和代乳品通常分布在超市四周。",
      "优先选择天然、成分单一的食物，而非深度加工的产品。",
      "选择当地时令产品：通常更亲民、更新鲜且营养更丰富。",
      "咨询商家：关于产地和种植方式，许多摊主都乐于分享。"
    ]
  },
  "messages": {
    "success": "Success!",
    "error": "Error",
    "saved": "Saved successfully",
    "updated": "Updated successfully",
    "deleted": "Deleted successfully",
    "confirmDelete": "Are you sure you want to delete this?",
    "networkError": "Network error. Please try again.",
    "somethingWrong": "Something went wrong",
    "failedToLoad": "Failed to load dashboard",
    "offlineMode": "Offline mode - showing limited data",
    "locationDenied": "Location access denied. Check browser settings to enable.",
    "locationUnavailable": "Location information unavailable",
    "locationTimeout": "Location request timed out. Please try again.",
    "locationError": "Unable to access location",
    "locationGranted": "Location access granted! Showing nearby options",
    "locationNotSupported": "Location services not supported by your browser",
    "requestingLocation": "Requesting location access..."
  },
  "trust": {
    "medicalDisclaimer": "Medical Disclaimer",
    "privacySecure": "Your data is private & secure",
    "dataEncrypted": "All data is encrypted and confidential",
    "notMedicalAdvice": "Not medical advice",
    "consultProvider": "Always consult your healthcare provider",
    "evidenceBased": "Evidence-based guidance",
    "generalEducation": "General health education",
    "preventiveGuidance": "Preventive guidance",
    "lifestyleSupport": "For awareness and lifestyle support",
    "lastUpdated": "Last updated",
    "expertReviewed": "Expert reviewed",
    "aiGenerated": "AI-generated insight",
    "disclaimerShort": "HealthLoop provides health education and is not a substitute for professional medical advice.",
    "disclaimerFull": "HealthLoop supports preventive wellness and early awareness. We provide health education, habit tracking, and wellness insights. This is not a substitute for licensed medical care. Always consult qualified healthcare providers for medical advice, diagnosis, or treatment.",
    "trustBanner": {
      "title": "HealthLoop is here to support your wellness journey",
      "description": "We provide general health education and preventive guidance based on trusted sources. This is not a substitute for professional medical advice. Always consult with qualified healthcare providers for medical decisions."
    }
  },
  "health": {
    "preventiveHealth": "Preventive Health Tracker",
    "educationHub": "Education Hub",
    "engagementWidget": "Engagement Widget",
    "wellnessCheckIn": "Wellness Check-In",
    "todaysMetrics": "Today's Metrics",
    "bloodPressure": "Blood Pressure",
    "heartRate": "Heart Rate",
    "weight": "Weight",
    "sleep": "Sleep",
    "waterIntake": "Water Intake",
    "exercise": "Exercise",
    "logMetric": "Log Metric",
    "viewHistory": "View History"
  },
  "aiInsights": {
    "title": "AI Health Insights",
    "comingSoon": "Your insights are gathering",
    "comingSoonDesc": "Complete a daily check-in or two and we'll surface gentle, personalised insights here.",
    "learnMore": "Learn more",
    "evidenceSources": {
      "WHO": "Based on WHO guidelines",
      "NHS": "Aligned with NHS recommendations",
      "CDC": "Supported by CDC guidelines",
      "RESEARCH": "Based on peer-reviewed research",
      "CLINICAL": "Backed by clinical studies"
    }
  },
  "dailyInsight": {
    "title": "Daily Health Insight",
    "gettingStarted": "Getting Started",
    "focus": "Focus",
    "quickInsight": "Quick Insight",
    "simpleExplanation": "Simple Explanation",
    "realLifeImpact": "Real-Life Impact",
    "yourActionStep": "Your Action Step",
    "basedOnYour": "Based on your",
    "personalizedFor": "Personalized for you based on your recent health data",
    "getNewInsight": "Get new insight",
    "newInsightLoaded": "New insight loaded! 💡",
    "failedToRefresh": "Failed to refresh insight",
    "priority": {
      "high": "Let's Focus Here",
      "medium": "Worth Noting"
    }
  },
  "preventiveAlerts": {
    "noAlertsTitle": "No health alerts at this time",
    "noAlertsDesc": "You're maintaining healthy habits. Keep it up!",
    "whatYouCanDo": "What you can do:",
    "viewMealSuggestions": "View Personalized Meal Suggestions"
  },
  "engagement": {
    "currentStreak": "Current Streak",
    "bestStreak": "Best Streak",
    "thisWeek": "This Week",
    "exerciseDays": "Exercise Days",
    "hydrationDays": "Hydration Days",
    "healthMetricsLogged": "Health Metrics Logged",
    "weeklyGoalsProgress": "Weekly Goals Progress",
    "completed": "completed",
    "days": "days",
    "keepGoing": "Keep going!",
    "personalRecord": "Personal record!",
    "goalMet": "Goal met!"
  },
  "reminders": {
    "title": "Health Reminders",
    "subtitle": "Stay on track with personalized health notifications",
    "breakfast": "Breakfast Reminder",
    "lunch": "Lunch Reminder",
    "dinner": "Dinner Reminder",
    "water": "Water Intake",
    "movement": "Movement Break",
    "sleep": "Sleep Reminder",
    "wellness": "Wellness Check-In",
    "healthLogging": "Health Logging",
    "annualCheckup": "Annual Checkup",
    "enable": "Enable",
    "disable": "Disable",
    "customize": "Customize Time",
    "stayConsistent": "Stay Consistent with Smart Reminders",
    "setupFriendly": "Set up friendly reminders to help you build healthy habits.",
    "customizeWhen": "You can customize when and how often you receive each reminder.",
    "supportive": "Don't worry - we'll keep them supportive and non-intrusive! 💚",
    "noPreferences": "No Reminder Preferences Found",
    "noPreferencesDesc": "We couldn't load your reminder settings. This might be your first time here, or there was an issue loading your preferences.",
    "retryLoading": "Retry Loading",
    "saveSettings": "Save Settings",
    "saving": "Saving..."
  },
  "empty": {
    "startJourney": "Start Your Wellness Journey",
    "startJourneyDesc": "Start your health journey today! Share how you're feeling to receive personalized insights and track your wellness over time.",
    "completeFirstCheckIn": "Complete First Check-in",
    "stayOnTrack": "Stay On Track",
    "stayOnTrackDesc": "Stay consistent with your routine 💊 Add your medications to get gentle reminders and support.",
    "addFirstMedication": "Add First Medication",
    "learnMedicationSafety": "Learn About Medication Safety",
    "buildMealLibrary": "Build Your Meal Library",
    "buildMealLibraryDesc": "No favorite meals yet. Save meals you love for quick access and easier meal planning.",
    "exploreMealOptions": "Explore Meal Options",
    "insightsAwait": "Your Insights Await",
    "insightsAwaitDesc": "Complete daily check-ins and track your wellness to unlock personalized health insights and pattern analysis.",
    "startDailyCheckIn": "Start Daily Check-in",
    "learnAboutInsights": "Learn About Insights",
    "buildingStory": "Building Your Wellness Story",
    "buildingStoryDesc": "No historical data yet. Your wellness trends and patterns will appear here as you complete daily check-ins.",
    "completeCheckIn": "Complete Check-in",
    "tipComplete7Days": "Tip: Complete check-ins for 7 days to see meaningful trends and patterns.",
    "startTrackingHabits": "Start Tracking Healthy Habits",
    "startTrackingHabitsDesc": "No habits tracked yet. Small daily actions create lasting wellness changes. Begin building your healthy routine today.",
    "trackFirstHabit": "Track First Habit",
    "getMoving": "Get Moving",
    "getMovingDesc": "No activity logged yet. Even 10 minutes of movement can boost your mood and energy.",
    "logActivity": "Log Activity",
    "allCaughtUp": "All Caught Up!",
    "allCaughtUpDesc": "You have no new notifications. Check back later for updates and wellness reminders.",
    "noResultsFound": "No Results Found",
    "noResultsFoundDesc": "We couldn't find any results for \"{query}\". Try adjusting your search or explore other options."
  },
  "footer": {
    "tagline": "Your AI-Powered Preventive Health Companion",
    "builtWith": "Built with care for your wellness journey",
    "allRightsReserved": "All rights reserved.",
    "about": "About",
    "privacy": "Privacy",
    "terms": "Terms",
    "contact": "Contact",
    "helpCenter": "Help Center"
  },
  "modals": {
    "feedback": {
      "title": "Share Your Feedback",
      "subtitle": "Help us improve HealthLoop",
      "whatWorking": "What's working well?",
      "whatImprove": "What could we improve?",
      "placeholder": "Share your thoughts...",
      "thankYou": "Thank you for your feedback!",
      "submitted": "Your feedback helps us make HealthLoop better."
    },
    "reportProblem": {
      "title": "Report a Problem",
      "subtitle": "Help us fix bugs and improve the app",
      "describe": "Describe the issue",
      "placeholder": "What happened? Please be as specific as possible...",
      "optional": "Optional: Steps to reproduce",
      "stepsPlaceholder": "1. I clicked on...\n2. Then I...",
      "thankYou": "Thank you for reporting!",
      "submitted": "We'll look into this right away."
    },
    "mealPreferences": {
      "title": "Customize Your Meals",
      "subtitle": "Tell us about your food preferences",
      "cuisines": "Preferred Cuisines",
      "selectCuisines": "Select all that apply",
      "dietary": "Dietary Preferences",
      "selectDietary": "Select your dietary needs",
      "allergies": "Allergies & Restrictions",
      "allergiesPlaceholder": "e.g., Nuts, Shellfish, Gluten",
      "save": "Save Preferences",
      "saving": "Saving..."
    },
    "upgrade": {
      "title": "Upgrade to Premium",
      "subtitle": "Unlock all features",
      "features": "Premium Features",
      "getStarted": "Get Started",
      "learnMore": "Learn More"
    }
  },
  "login": {
    "title": "Your Preventive Health Intelligence Platform",
    "subtitle": "Track, learn, and take action before problems escalate. Built for prevention, education, engagement, and wellness.",
    "email": "Email",
    "password": "Password",
    "signIn": "Sign In",
    "signingIn": "Signing in...",
    "forgotPassword": "Forgot Password?",
    "noAccount": "Don't have an account?",
    "createAccount": "Create one",
    "biometricLogin": "Sign in with Biometrics",
    "biometricHelper": "Use fingerprint, Face ID, or Windows Hello",
    "authenticating": "Authenticating...",
    "vendorPartner": "Are you a vendor partner?",
    "vendorLogin": "Vendor Login",
    "emailRequired": "Please enter your email first",
    "biometricSuccess": "Successfully signed in with biometrics! 🎉",
    "noPasskeys": "No biometric login set up. Please use password login first.",
    "biometricCancelled": "Biometric login cancelled",
    "biometricFailed": "Biometric login failed. Please try password login."
  },
  "register": {
    "title": "加入 HealthLoop",
    "subtitle": "今天开始您的预防保健之旅",
    "fullName": "姓名",
    "email": "邮箱",
    "password": "密码",
    "confirmPassword": "确认密码",
    "createAccount": "创建账户",
    "haveAccount": "已有账户？",
    "signIn": "登录",
    "creating": "正在创建账户…",
    "passwordTooShort": "密码至少需 8 个字符",
    "setupBiometric": "设置生物识别登录",
    "setupBiometricDesc": "使用指纹、面容 ID 或 Windows Hello 实现更快更安全的登录",
    "setupNow": "立即设置",
    "skipForNow": "暂不设置",
    "settingUp": "正在设置…",
    "benefit1": "无需记住密码",
    "benefit2": "生物识别增强安全",
    "benefit3": "一触或一瞥即可登录",
    "biometricPrivacy": "您的生物识别数据始终保留在设备上",
    "biometricSuccess": "生物识别登录设置成功！🎉",
    "biometricFailed": "生物识别设置失败。您可以稍后在设置中配置。",
    "biometricSetupLater": "您可以稍后在个人资料设置中配置生物识别登录"
  },
  "womensHealthPage": {
    "title": "Women's Health Tracker",
    "subtitle": "Track your cycle, symptoms, and wellness",
    "cycleOverview": "Cycle Overview",
    "currentPhase": "Current Phase",
    "nextPeriod": "Next Period Expected",
    "logPeriod": "Log Period",
    "logSymptoms": "Log Symptoms",
    "insights": "Cycle Insights",
    "tips": "Phase-Based Tips",
    "history": "Period History",
    "noData": "No cycle data yet",
    "noDataDesc": "Start tracking your cycle to receive personalized insights and predictions.",
    "startTracking": "Start Tracking"
  },
  "notifications": {
    "title": "Notifications",
    "markAllRead": "Mark All as Read",
    "noNotifications": "No new notifications",
    "viewAll": "View All"
  },
  "familyHealth": {
    "title": "Family & Child Health",
    "subtitle": "Preventive health support for your entire family",
    "tabImmunizations": "Immunizations",
    "tabEducation": "Education",
    "tabReminders": "Reminders",
    "tabPlanner": "Family Planner",
    "immunizations": {
      "title": "Immunization Awareness",
      "subtitle": "Stay informed about recommended vaccines",
      "recommendedSchedule": "Recommended Schedule",
      "byAge": "By Age Group",
      "infants": "Infants (0-12 months)",
      "toddlers": "Toddlers (1-3 years)",
      "preschool": "Preschool (4-6 years)",
      "schoolAge": "School Age (7-12 years)",
      "teens": "Teens (13-18 years)",
      "adults": "Adults",
      "learnMore": "Learn More",
      "consultDoctor": "Always consult your healthcare provider for personalized vaccine recommendations",
      "upcomingReminders": "Upcoming Vaccine Reminders",
      "noReminders": "No upcoming vaccine reminders",
      "addReminder": "Add Vaccine Reminder",
      "reminderFor": "Reminder for",
      "dueDate": "Due Date",
      "notes": "Notes",
      "markComplete": "Mark Complete"
    },
    "education": {
      "title": "Family Health Education",
      "subtitle": "Evidence-based preventive health information",
      "categories": "Categories",
      "infant": "Infant Care",
      "child": "Child Development",
      "nutrition": "Nutrition & Growth",
      "safety": "Safety & Prevention",
      "mental": "Mental Wellness",
      "hygiene": "Hygiene & Habits",
      "searchPlaceholder": "Search health topics...",
      "popularTopics": "Popular Topics",
      "readMore": "Read More",
      "readTime": "min read"
    },
    "reminders": {
      "title": "Family Health Reminders",
      "subtitle": "Stay on track with preventive care for the whole family",
      "createReminder": "Create Reminder",
      "familyMember": "Family Member",
      "reminderType": "Reminder Type",
      "frequency": "Frequency",
      "activeReminders": "Active Reminders",
      "upcomingThisWeek": "Upcoming This Week",
      "noActiveReminders": "No active reminders",
      "types": {
        "checkup": "Health Checkup",
        "dental": "Dental Visit",
        "vision": "Vision Screening",
        "vaccine": "Vaccination",
        "medication": "Medication",
        "custom": "Custom"
      }
    },
    "planner": {
      "title": "Family Health Planner",
      "subtitle": "Coordinate preventive care for your family",
      "addMember": "Add Family Member",
      "memberName": "Member Name",
      "relationship": "Relationship",
      "dateOfBirth": "Date of Birth",
      "viewCalendar": "View Calendar",
      "upcomingCare": "Upcoming Preventive Care",
      "nothingScheduled": "Nothing scheduled yet",
      "scheduleCheckup": "Schedule Checkup",
      "relationships": {
        "child": "Child",
        "spouse": "Spouse",
        "parent": "Parent",
        "sibling": "Sibling",
        "other": "Other"
      }
    },
    "content": {
      "infantCare": {
        "title": "Infant Preventive Care",
        "intro": "Essential preventive health practices for your baby's first year",
        "topics": [
          "Well-baby checkup schedule",
          "Developmental milestones to watch",
          "Safe sleep practices",
          "Nutrition and feeding",
          "Immunization schedule"
        ]
      },
      "childDevelopment": {
        "title": "Child Development & Milestones",
        "intro": "Understanding healthy growth and development",
        "topics": [
          "Physical development milestones",
          "Social and emotional growth",
          "Language development",
          "Cognitive milestones",
          "When to talk to your doctor"
        ]
      },
      "nutrition": {
        "title": "Nutrition & Healthy Growth",
        "intro": "Building healthy eating habits from the start",
        "topics": [
          "Age-appropriate nutrition",
          "Healthy snack ideas",
          "Managing picky eaters",
          "Food safety basics",
          "Hydration guidelines"
        ]
      },
      "safety": {
        "title": "Safety & Injury Prevention",
        "intro": "Creating a safe environment for your family",
        "topics": [
          "Home safety checklist",
          "Car seat safety",
          "Water safety",
          "Poison prevention",
          "Emergency preparedness"
        ]
      }
    }
  }
};
